import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';
import { FontFamily } from '../Font/fontConstants';

const siteNameFontVars: Pick<
  MotifComponentProps<MotifComponent.HEADER>,
  '--global-header-site-name-font-family' | '--global-header-site-name-font-size'
> = {
  '--global-header-site-name-font-family': `${FontFamily.PROGRAM_OT}, Helvetica, Tahoma, Arial, sans-serif`,
  '--global-header-site-name-font-size': '20px',
};

export const darkThemeHeaderVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...siteNameFontVars,
  '--global-header-bg-color': m('--neutral-v700'),
  '--global-header-border-color': 'transparent',
  '--global-header-fg-color': m('--neutral-v300'),
  '--global-header-nav-screen-bg-color': m('--neutral-v700'),
  '--global-header-nav-screen-fg-color': m('--neutral-v300'),
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v650'),
  '--global-header-item-color': m('--action-text-default-color'),
  '--global-header-item-hover-color': m('--action-text-hover-color'),
  '--global-header-item-active-color': m('--action-text-active-color'),
  '--global-header-indicator-hover-color': m('--action-indicator-hover-color'),
  '--global-header-indicator-active-color': m('--action-indicator-active-color'),
  '--global-header-navigator-item-color': m('--action-text-default-color'),
  '--global-header-navigator-item-desktop-font-text-transform': 'none',
  '--global-header-navigator-item-mobile-font-text-transform': 'none',
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-active-color': m('--action-text-active-color'),
  '--global-header-navigator-indicator-hover-color': m('--action-indicator-hover-color'),
  '--global-header-navigator-indicator-active-color': m('--action-indicator-active-color'),
  '--global-header-menu-bg-color': m('--neutral-v650'),
  '--global-header-menu-border-color': m('--neutral-v625'),
  '--global-header-menu-col-label-color': m('--neutral-v0'),
  '--global-header-menu-col-divider-color': m('--neutral-v600'),
  '--global-header-menu-item-fg-color': m('--action-text-default-color'),
  '--global-header-menu-item-hover-color': m('--action-text-hover-color'),
  '--global-header-menu-item-active-color': m('--action-text-active-color'),
  '--global-header-menu-item-icon-color': m('--primary-v150'),
  '--global-header-menu-item-bg-hover-color': m('--neutral-v625'),
  '--global-header-menu-featured-item-bg-color': m('--neutral-v600'),
  '--global-header-menu-featured-item-bg-hover-color': m('--neutral-v625'),
  '--global-header-menu-featured-item-fg-color': m('--neutral-v300'),
  '--global-header-menu-featured-item-hover-color': m('--action-text-hover-color'),
  '--global-header-menu-featured-item-active-color': m('--action-text-active-color'),
  '--global-header-menu-featured-item-icon-color': m('--primary-v150'),
};

export const transparentDarkThemeHeaderVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...darkThemeHeaderVars,
  '--global-header-border-color': 'transparent',
  '--global-header-bg-color': m('--palette-plain-transparent'),
  '--global-header-nav-screen-bg-color': m('--neutral-v700'),
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v650'),
  '--global-header-navigator-item-color': m('--action-text-default-color'),
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-active-color': m('--action-text-active-color'),
};

export const lightThemeHeaderVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...siteNameFontVars,
  '--global-header-border-color': 'transparent',
  '--global-header-bg-color': m('--neutral-v0'),
  '--global-header-fg-color': m('--neutral-v600'),
  '--global-header-nav-screen-bg-color': m('--neutral-v0'),
  '--global-header-nav-screen-fg-color': m('--neutral-v600'),
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v150'),
  '--global-header-item-color': m('--action-text-default-color'),
  '--global-header-item-hover-color': m('--action-text-hover-color'),
  '--global-header-item-active-color': m('--action-text-active-color'),
  '--global-header-indicator-hover-color': m('--action-indicator-hover-color'),
  '--global-header-indicator-active-color': m('--action-indicator-active-color'),
  '--global-header-navigator-item-color': m('--action-text-default-color'),
  '--global-header-navigator-item-desktop-font-text-transform': 'none',
  '--global-header-navigator-item-mobile-font-text-transform': 'none',
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-active-color': m('--action-text-active-color'),
  '--global-header-navigator-indicator-hover-color': m('--action-indicator-hover-color'),
  '--global-header-navigator-indicator-active-color': m('--action-indicator-active-color'),
  '--global-header-menu-bg-color': m('--neutral-v0'),
  '--global-header-menu-border-color': m('--neutral-v150'),
  '--global-header-menu-col-label-color': m('--neutral-v700'),
  '--global-header-menu-col-divider-color': m('--neutral-v150'),
  '--global-header-menu-item-fg-color': m('--action-text-default-color'),
  '--global-header-menu-item-hover-color': m('--action-text-hover-color'),
  '--global-header-menu-item-active-color': m('--action-text-active-color'),
  '--global-header-menu-item-icon-color': m('--neutral-v500'),
  '--global-header-menu-item-bg-hover-color': m('--neutral-v200'),
  '--global-header-menu-featured-item-bg-color': m('--neutral-v150'),
  '--global-header-menu-featured-item-bg-hover-color': m('--neutral-v200'),
  '--global-header-menu-featured-item-fg-color': m('--neutral-v650'),
  '--global-header-menu-featured-item-hover-color': m('--action-text-hover-color'),
  '--global-header-menu-featured-item-active-color': m('--action-text-active-color'),
  '--global-header-menu-featured-item-icon-color': m('--neutral-v500'),
};

export const transparentLightThemeHeaderVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...lightThemeHeaderVars,
  '--global-header-bg-color': m('--palette-plain-transparent'),
  '--global-header-nav-screen-bg-color': m('--neutral-v0'),
  '--global-header-nav-screen-global-links-bg-color': m('--neutral-v150'),
  '--global-header-navigator-item-color': m('--action-text-default-color'),
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-active-color': m('--action-text-active-color'),
};

export const yellowThemeHeaderVars: MotifComponentProps<MotifComponent.HEADER> = {
  ...lightThemeHeaderVars,
  '--global-header-bg-color': m('--primary-v100'),
  '--global-header-nav-screen-bg-color': m('--neutral-v0'),
  '--global-header-navigator-item-color': m('--action-text-default-color'),
  '--global-header-navigator-item-hover-color': m('--action-text-hover-color'),
  '--global-header-navigator-item-active-color': m('--action-text-active-color'),
};
